"use client";

import { format } from "date-fns";
import { DayPickerRangeProps, Matcher } from "react-day-picker";

import { TbCalendar } from "react-icons/tb";
import { cn } from "../../lib/utils";
import { Button } from "../Button";
import { Calendar } from "../Calendar";
import { Popover, PopoverContent, PopoverTrigger } from "../Popover";
import { t } from "i18next";
import { DateTime } from "luxon";

interface DatePickerWithRangeProps extends DayPickerRangeProps {
  disabled?: Matcher | undefined;
}

export function DatePickerWithRange({
  mode = "range",
  className,
  selected,
  onSelect,
  disabled = undefined,
}: DatePickerWithRangeProps) {
  return (
    <div className={cn("grid gap-2", className)}>
      <Popover>
        <PopoverTrigger asChild>
          <Button
            id="date"
            variant="outline"
            size="datepicker"
            className={cn(
              "w-min-content justify-start text-left font-normal",
              !selected && "text-muted-foreground"
            )}
          >
            <TbCalendar className="mr-2 h-4 w-4" />
            {selected?.from ? (
              selected?.to ? (
                <>
                  {format(selected?.from, "dd.MM.y")} - {format(selected?.to, "dd.MM.y")}
                </>
              ) : (
                format(selected?.from, "dd.MM.y")
              )
            ) : (
              <span>{t("pick_a_date")}</span>
            )}
          </Button>
        </PopoverTrigger>
        <PopoverContent className="w-auto p-0" align="end">
          <Calendar
            initialFocus
            mode="range"
            defaultMonth={DateTime.local().minus({month: 1}).toJSDate()}
            selected={selected}
            onSelect={onSelect}
            numberOfMonths={2}
            disabled={disabled}
          />
        </PopoverContent>
      </Popover>
    </div>
  );
}
